export const ANALYSIS_RUBRIC_REQUIRED_CODE = "ANALYSIS_RUBRIC_REQUIRED";
export const ROLE_SETUP_REQUIRED_CODE = "ROLE_SETUP_REQUIRED";

export const isAnalysisRubricRequiredDetail = (detail) =>
  detail?.code === ANALYSIS_RUBRIC_REQUIRED_CODE;
